import React, { Component } from 'react';
import './style.css';

const CompleteProfileItem = (text, checked) => {
  const fileName = checked ? 'green-check.png' : 'gray-check.png';
  return (
    <div key={text} className="complete-profile__item d-flex align-items-center my-4">
      <img className="mr-4" style={{ width: 24 }} src={`/assets/${fileName}`} alt="check" />
      <p className="m-0">{text}</p>
    </div>
  );
};

class CompleteProfile extends Component {
  constructor(props) {
    super(props);

    const { profileDataStatus } = props;

    const completed = profileDataStatus.filter(item => item.value).length;
    const completionPercentage = (completed / profileDataStatus.length) * 100;

    this.state = {
      profileDataStatus,
      completionPercentage
    };
  }

  render() {
    const { profileDataStatus, completionPercentage } = this.state;

    return (
      <div className="complete-profile card mb-3">
        <div className="complete-profile__header d-flex align-items-center justify-content-between p-4">
          <p className="complete-profile__header-text m-0">Complete your profile</p>
          <p className="m-0">{Math.round(completionPercentage)}%</p>
        </div>
        <div className="complete-profile__progress">
          <div
            className="complete-profile__progress-bar"
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
        <div className="px-4 py-2">
          {profileDataStatus.map(item => CompleteProfileItem(item.text, item.value))}
        </div>
      </div>
    );
  }
}

export default CompleteProfile;



// WEBPACK FOOTER //
// ./src/pages/teacher/Home/CompleteProfile/index.js